/* Reuse translated product HTML; split presentation wrappers into existing brick faces. */
(()=>{
 const rows=()=>{
 document.querySelectorAll('.pm-collection-section,.recently-viewed--section').forEach(section=>{
  if(!section.classList.contains('pm-builder-page'))section.classList.add('pm-builder-page');
 const wrapper=section.querySelector('.product-recently-viewed__wrapper');if(wrapper&&!wrapper.classList.contains('pm-inner'))wrapper.classList.add('pm-inner');
  const inner=section.querySelector('.product-recently-viewed__wrapper');if(inner&&!inner.classList.contains('pm-inner'))inner.classList.add('pm-inner');
  section.querySelectorAll('.product-recently-viewed__header,.productgrid--sidebar,.productgrid--item:not(.pm-category-card),.pagination--container').forEach(face=>{if(!face.classList.contains('pm-brick'))face.classList.add('pm-brick');});
 });
};
const build=()=>{rows();
 document.querySelectorAll('[data-pm-collection-description]:not([data-pm-product-built])').forEach(root=>{
  root.dataset.pmProductBuilt='true';
  const output=document.createDocumentFragment();let face=null;
  const flush=()=>{face=null;};
  const add=node=>{if(!face){face=document.createElement('div');face.className='pm-brick pm-product-copy';output.append(face);}face.append(node);};
  const walk=parent=>{
   [...parent.childNodes].forEach(node=>{
    if(node.nodeType===3){if(node.textContent.trim())add(node);return;}
    if(node.nodeType!==1)return;
    if(node.matches('style,script,link')){output.append(node);return;}
    if(node.matches('div,section,article')){
     const grid=/display\s*:\s*grid/i.test(node.getAttribute('style')||'')||getComputedStyle(node).display==='grid';
     if(grid){flush();const row=document.createElement('div');row.className='pm-product-facts';[...node.children].forEach(item=>{item.removeAttribute('style');item.classList.add('pm-brick');row.append(item);});output.append(row);flush();}
     else{flush();walk(node);flush();}
     return;
    }
    if(node.matches('h1,h2,h3,h4,h5,h6'))flush();
    if(node.matches('p')&&!node.textContent.trim()&&!node.querySelector('img,iframe,video'))return;
    node.removeAttribute('style');add(node);
   });
  };
  walk(root);root.replaceChildren(output);
 });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',build,{once:true});else build();
 document.addEventListener('shopify:section:load',build);
 let rowsQueued=false;
 const scheduleRows=()=>{if(rowsQueued)return;rowsQueued=true;requestAnimationFrame(()=>{rowsQueued=false;rows();});};
 const watch=new MutationObserver(records=>{if(records.some(r=>[...r.addedNodes].some(n=>n.nodeType===1&&!n.matches('.pm-mould-stud'))))scheduleRows();});
 const main=document.querySelector('#site-main');if(main)watch.observe(main,{childList:true,subtree:true});
})();
/* The compact cards use the existing controls without the legacy card controller. */
document.addEventListener('click',event=>{
 const button=event.target.closest('[data-collection-view]');
 const section=button?.closest('.pm-collection');
 if(!section)return;
 const view=button.dataset.collectionView;
 if(view!=='grid-view'&&view!=='list-view')return;
 event.preventDefault();event.stopImmediatePropagation();
 const outer=section.querySelector('[data-productgrid-outer]');
 outer.classList.toggle('productgrid-gridview',view==='grid-view');
 outer.classList.toggle('productgrid-listview',view==='list-view');
 section.querySelectorAll('[data-collection-view]').forEach(control=>{
  const active=control.dataset.collectionView===view;
  control.classList.toggle('active',active);
  control.setAttribute('aria-pressed',String(active));
 });
},true);

